<template>
    <div class="pagination-container">
        <div class="pagination-info">
            전체 {{ totalItems }}개 중 {{ paginationStart + 1 }}-{{ paginationEnd }}개 표시
        </div>
        <div class="pagination-controls">
            <button class="btn-pagination" :disabled="currentPage === 1" @click="goToPage(1)" title="첫 페이지">
                <i class="fas fa-angle-double-left"></i>
            </button>
            <button
                class="btn-pagination"
                :disabled="currentPage === 1"
                @click="goToPage(currentPage - 1)"
                title="이전 페이지"
            >
                <i class="fas fa-angle-left"></i>
            </button>

            <div class="pagination-pages">
                <button
                    v-for="page in visiblePages"
                    :key="page"
                    class="btn-pagination"
                    :class="{ ACTIVE: currentPage === page }"
                    @click="goToPage(page)"
                >
                    {{ page }}
                </button>
            </div>

            <button
                class="btn-pagination"
                :disabled="currentPage === totalPages"
                @click="goToPage(currentPage + 1)"
                title="다음 페이지"
            >
                <i class="fas fa-angle-right"></i>
            </button>
            <button
                class="btn-pagination"
                :disabled="currentPage === totalPages"
                @click="goToPage(totalPages)"
                title="마지막 페이지"
            >
                <i class="fas fa-angle-double-right"></i>
            </button>
        </div>
        <div class="pagination-size">
            <CarbonSelect
                :value="pageSize"
                :options="pageSizeSelectOptions"
                @input="onPageSizeInput"
            />
        </div>
    </div>
</template>

<script>
import CarbonSelect from "./CarbonSelect.vue";

export default {
    name: "TablePagination",
    components: { CarbonSelect },
    props: {
        totalItems: {
            type: Number,
            default: 0,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        pageSize: {
            type: Number,
            default: 10,
        },
        pageSizeOptions: {
            type: Array,
            default: () => [10, 20, 50, 100],
        },
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalItems / this.pageSize) || 1;
        },
        paginationStart() {
            return (this.currentPage - 1) * this.pageSize;
        },
        paginationEnd() {
            return Math.min(this.paginationStart + this.pageSize, this.totalItems);
        },
        visiblePages() {
            const pages = [];
            const maxVisible = 5;
            let startPage = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
            let endPage = Math.min(this.totalPages, startPage + maxVisible - 1);
            if (endPage - startPage < maxVisible - 1) {
                startPage = Math.max(1, endPage - maxVisible + 1);
            }
            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
            return pages;
        },
        pageSizeSelectOptions() {
            return this.pageSizeOptions.map((n) => ({ value: n, text: `${n}개씩` }));
        },
    },
    methods: {
        goToPage(page) {
            this.$emit("update:currentPage", page);
        },
        onPageSizeChange(e) {
            const val = Number(e.target.value);
            this.$emit("update:pageSize", val);
            this.$emit("update:currentPage", 1);
        },
        onPageSizeInput(val) {
            const num = typeof val === "number" ? val : Number(val);
            this.$emit("update:pageSize", num);
            this.$emit("update:currentPage", 1);
        },
    },
};
</script>

<style scoped>
.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
}

.pagination-info {
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
}

.pagination-controls {
    display: flex;
    gap: 4px;
    align-items: center;
}

.pagination-pages {
    display: flex;
    gap: 4px;
    margin: 0 8px;
}

.btn-pagination {
    padding: 0 8px;
    background: transparent;
    border: 1px solid #ced4da;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    color: #64748b;
    font-size: 13px;
}

.btn-pagination:hover:not(:disabled) {
    background: #f0f9f4;
    border-color: #52b788;
}

.btn-pagination:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.btn-pagination.ACTIVE {
    background: #52b788;
    border-color: #52b788;
    color: white;
    font-weight: 600;
}

.btn-pagination.ACTIVE:hover {
    background: #52b788;
    border-color: #52b788;
    color: white;
}

.pagination-size .select-compact {
    min-width: 100px;
}

@media (max-width: 768px) {
    .pagination-container {
        flex-direction: column;
        gap: 12px;
        align-items: stretch;
    }

    .pagination-info {
        text-align: center;
    }

    .pagination-controls {
        justify-content: center;
    }

    .pagination-size {
        justify-content: center;
    }
}
</style>
